import { Component, PLATFORM_ID, Inject} from '@angular/core'; 
import { UserService } from './shared/services/user.service';
import { AuthenticationService } from './shared/services/authentication.service';
import Swal from 'sweetalert2';
@Component({
    standalone: false,
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})export class AppComponent  {
   
    timeout: any;
    roleChangeAlertShown: boolean = false;
    ChangeRole: boolean = false;
    countdownValue: number = 30;
    intervalId: any;
  constructor(@Inject(PLATFORM_ID) private readonly platformId: Object,
         private readonly uesrmanagementService: UserService,
      private readonly as: AuthenticationService
  ) {
  }
async loadUserData() {
        if (!this.ChangeRole) {
            const user = localStorage.getItem('userRoleName');
            try {
                if (user) {
                    const userid = this.as.getUserEmail();
                    this.uesrmanagementService.getUsers().then(resdata => {
                        const matchedUser = resdata.find(user => user.emailId === userid);

                        if (matchedUser && matchedUser.userRoleName !== user) {
                            this.ChangeRole = true;
                            clearInterval(this.timeout); 
                            if (!this.roleChangeAlertShown) {
                                this.roleChangeAlertShown = true;
                                this.Roleload();
                            }
                        }
                    }).catch(error => {
                        console.error("An error occurred while checking the user role:", error);
                    });
                }
            } catch (e) {
                console.error("An error occurred:", e);
            }
        }
    }
Roleload() {
        Swal.fire({
            title: 'Your Role is Changed',
            text: 'Please Logout and Login',
            showConfirmButton: true,
            confirmButtonText: "Logout",
            icon: 'warning',
            showCancelButton: false,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            allowEscapeKey: false,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.value) {
                this.as.logout();
            }
        });
    }
    ngOnDestroy() {
        clearInterval(this.timeout); 
        clearInterval(this.intervalId);
        this.ChangeRole = false;
        this.roleChangeAlertShown = false;
        Swal.close();
    }
}